import { mapToCanActivate, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import { AuthGuardService, CanActivateGuardService } from '@app/shared/services'
import { salesSchoolRegistrationGuard } from '@ssRegistrationShared/sales-school-registration.guard'
import { MerchandiseReturnsAuthGuardService } from '@merchandiseReturnsShared/merchandise-returns-auth-guard.service'
import { AppLinksComponent, DashboardComponent, InternalShellComponent } from '../containers'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { AccountGuardService } from '../account/shared/account-guard.service'
import { SetDealerComponent } from './components/set-dealer/set-dealer.component'

const internalRoutes = SITE_DIRECTORY_ROUTES.internal

const childInternalRoutes: Routes = [
   {
      path: '',
      component: DashboardComponent
   },
   {
      path: SITE_DIRECTORY_ROUTES.internal.app_links.baseUri,
      component: AppLinksComponent
   },
   //...ACCOUNT_ROUTES, /* If NOT lazy-loading */
   {
      path: internalRoutes.account.baseUri,
      canActivate: mapToCanActivate([AccountGuardService]),
      loadChildren: () =>
         import('@account/account.routes').then(
            routes => routes.ACCOUNT_ROUTES
         )
   },
   //...MERCHANDISE_RETURNS_ROUTES, /* If NOT lazy-loading */
   {
      path: internalRoutes.merchandise_returns.baseUri,
      canActivate: mapToCanActivate([MerchandiseReturnsAuthGuardService]),
      loadChildren: () =>
         import('@merchandiseReturns/merchandise-returns.routes').then(
            routes => routes.MERCHANDISE_RETURNS_ROUTES
         )
   },
   {
      path: internalRoutes.sales_school_registration.baseUri,
      /*https://stackoverflow.com/questions/75564717/angulars-canactivate-interface-is-deprecated-how-to-replace-it#:~:text=An%20injectable%20class%20can%20be,the%20child%20class%20is%20deprecated.*/
      canActivate: [salesSchoolRegistrationGuard],
      loadComponent: () =>
         import('@app/sales-school-registration/containers/shell/shell.component').then(
            comp => comp.SalesSchoolRegistrationShellComponent
         )
   },
   {
      path: SITE_DIRECTORY_ROUTES.internal.set_dealer.baseUri,
      component: SetDealerComponent
   },
]

export const INTERNAL_ROUTES: Routes = [
   {
      path: internalRoutes.baseUri, /* If not lazy-loading contentRoutes.baseUri, else '' */
      component: InternalShellComponent,
      canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService], /* remove if lazy-loading */
      children: childInternalRoutes
   }
]
